import { render } from "./ModalLayout.vue?vue&type=template&id=68cf6634&scoped=true"
import script from "./ModalLayout.vue?vue&type=script&lang=js"
export * from "./ModalLayout.vue?vue&type=script&lang=js"

import "./ModalLayout.vue?vue&type=style&index=0&id=68cf6634&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cf6634"]])

export default __exports__